export enum ChainEnum {
  NotSelected = "Unknown",
  Ethereum = "Ethereum",
  SepoliaTestnet = "Sepolia Testnet",
  BasecampTestnet = "Basecamp Testnet",
  MegaethTestnet = "MegaETH Testnet",
  Optimism = "Optimism",
  Arbitrum = "Arbitrum",
  OptimismTestnet = "Optimism Sepolia",
  ArbitrumTestnet = "Arbitrum Sepolia",
  DogeosTestnet = "Dogeos Testnet",
  MonadTestnet = "Monad Testnet",
  ArcTestnet = "Arc Testnet",
  BnbTestnet = "BNB Testnet",
}
// On dev, ETH_MAINNET is LOCAL

export enum ChainIdEnum {
  NONE = -1,
  ETH_MAINNET = 1,
  SEPOLIA_TESTNET = 11155111,
  BASECAMP_TESTNET = 123420001114,
  MEGAETH_TESTNET = 6343,
  OPTIMISM = 10,
  OPTIMISM_TESTNET = 11155420,
  ARBITRUM = 42161,
  ARBITRUM_TESTNET = 421614,
  DOGEOS_TESTNET = 6281971,
  MONAD_TESTNET = 10143,
  ARC_TESTNET = 5042002,
  BNB_TESTNET = 97,
}

// Aevo-inherited Socket-bridge deposit sources. MarginX deploys no Socket vaults,
// so the cross-chain deposit flow these gate (depositERC20OptimismOrArbitrum et al)
// has nowhere legitimate to send funds — the list is intentionally EMPTY, which
// removes the OP/Arbitrum tiles from the deposit modal and routes every deposit
// through the native-chain path. Re-populate only if a real bridge integration ships.
export const SOCKET_DEPOSIT_CHAINS: ChainIdEnum[] = [];

// Chain IDs that use UnifiedVault deposit flow (perpetual DEX)
export const UNIFIED_VAULT_CHAIN_IDS: ChainIdEnum[] = [
  ChainIdEnum.BASECAMP_TESTNET,
  ChainIdEnum.MEGAETH_TESTNET,
  ChainIdEnum.DOGEOS_TESTNET,
  ChainIdEnum.MONAD_TESTNET,
  ChainIdEnum.ARC_TESTNET,
  ChainIdEnum.BNB_TESTNET,
];

export const AllChainIdEnum: ChainIdEnum[] = Object.values(ChainIdEnum).filter(
  (v) => !Number.isNaN(Number(v))
) as ChainIdEnum[];

export enum AltChainIdEnum {
  GOERLI = 5,
  BINANCE = 56,
  POLYGON = 137,
  FANTOM = 250,
  BOBA = 288,
  MOONBEAM = 1284,
  EVMOS = 9001,
  CELO = 42220,
  OASIS = 42262,
  AVALANCHE = 43114,
  AURORA = 1313161554,
  HARMONY = 1666600000,
}

export const AllAltChainIdEnum: AltChainIdEnum[] = Object.values(
  AltChainIdEnum
).filter((v) => !Number.isNaN(Number(v))) as AltChainIdEnum[];
